import { Card, Grid, TextInput } from '@mantine/core';

const SettingsTabGTM = ({ domain, handleChange, gtmValid }) => {
  return (
    <Card withBorder>
      <Card.Section p="md">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>GTM Id</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput
              name="gtmId"
              placeholder="GTM-XXXXXXX"
              value={domain.gtmId || ''}
              error={domain.gtmId && !gtmValid ? 'Value is invalid!' : null}
              onChange={handleChange}
            />
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SettingsTabGTM;
